import { inject, type InjectionKey } from 'vue';

export type PromptFn = (message?: string) => Promise<boolean>;

export type PromptVariant = 'delete' | 'confirm';

export const deletePromptKey = Symbol('jk/delete-prompt') as InjectionKey<PromptFn>;
export const useDeletePrompt = () => inject(deletePromptKey);

export const confirmPromptKey = Symbol('jk/confirm-prompt') as InjectionKey<PromptFn>;
export const useConfirmPrompt = () => inject(confirmPromptKey);
